import { configureStore } from "@reduxjs/toolkit";
import main from "./mainSlice";
import user from "./userSlice";

export const store = configureStore({
  reducer: {
    main,
    user,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
